import classNames from 'classnames';

export const addClassName = ({ htmlProps, classes, shouldAdd = true }) => ({
  ...htmlProps,
  className: classNames(shouldAdd ? classes : null, htmlProps.className),
});
